(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["column-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * Column slider helpers:
   * 1. refs.slides を DOM から強制同期（Component が拾えない場合がある）
   * 2. next/previous を scrollBy ベースに差し替え
   */
  function getColumnSliderScroller(slideshow) {
    return slideshow.refs?.scroller || slideshow.querySelector('slideshow-slides');
  }

  function collectColumnSliderSlides(scroller) {
    return Array.from(scroller.children).filter(
      (child) =>
        child.matches('slideshow-slide.column-slide, .column-slide') || child.classList.contains('group-block')
    );
  }

  function getColumnSliderSlides(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    if (!scroller) return [];

    if (slideshow.refs?.slides?.length) return slideshow.refs.slides;

    return collectColumnSliderSlides(scroller);
  }

  function syncColumnSliderRefs(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    if (!scroller) return [];

    const slides = collectColumnSliderSlides(scroller);

    slides.forEach((slide) => {
      slide.setAttribute('ref', 'slides[]');
    });

    if (typeof slideshow.updatedCallback === 'function') {
      slideshow.updatedCallback();
    }

    if (!slideshow.refs?.slides?.length && slides.length) {
      slideshow.refs = Object.assign({}, slideshow.refs, { slides });
    }

    if (!slideshow.refs?.scroller) {
      slideshow.refs = Object.assign({}, slideshow.refs, { scroller });
    }

    return slideshow.refs?.slides || slides;
  }

  function getColumnSliderStep(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    const slide = getColumnSliderSlides(slideshow)[0];
    if (!scroller || !slide) return 0;

    const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function getColumnSliderMaxScroll(scroller) {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function updateColumnSliderControls(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    const { previous, next } = slideshow.refs || {};
    if (!scroller) return;

    const maxScroll = getColumnSliderMaxScroll(scroller);
    const atStart = scroller.scrollLeft <= 1;
    const atEnd = scroller.scrollLeft >= maxScroll - 1;

    if (previous) previous.disabled = atStart;
    if (next) next.disabled = maxScroll <= 1 || atEnd;
  }

  function syncColumnSliderCurrent(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    const slides = getColumnSliderSlides(slideshow);
    if (!scroller || !slides.length) return;

    const scrollerRect = scroller.getBoundingClientRect();
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - scrollerRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    slideshow.current = closestIndex;
    updateColumnSliderControls(slideshow);
  }

  function scrollColumnSlider(slideshow, direction, options = {}) {
    syncColumnSliderRefs(slideshow);

    const scroller = getColumnSliderScroller(slideshow);
    if (!scroller) return;

    const step = getColumnSliderStep(slideshow);
    if (!step) return;

    const maxScroll = getColumnSliderMaxScroll(scroller);
    const instant = options.animate === false;
    const target = Math.max(0, Math.min(scroller.scrollLeft + direction * step, maxScroll));

    scroller.scrollTo({
      left: target,
      behavior: instant ? 'auto' : 'smooth',
    });

    slideshow.setAttribute('actioned', '');
    requestAnimationFrame(() => syncColumnSliderCurrent(slideshow));
  }

  function bindColumnSliderScroller(slideshow) {
    const scroller = getColumnSliderScroller(slideshow);
    if (!scroller || scroller.dataset.columnSliderBound === 'true') return;

    scroller.dataset.columnSliderBound = 'true';
    scroller.addEventListener(
      'scroll',
      () => {
        syncColumnSliderCurrent(slideshow);
      },
      { passive: true }
    );
  }

  function enhanceColumnSliderNavigation() {
    const Slideshow = customElements.get('slideshow-component');
    if (!Slideshow?.prototype || Slideshow.prototype.__columnSliderScrollFix) return;

    const originalNext = Slideshow.prototype.next;
    const originalPrevious = Slideshow.prototype.previous;

    Slideshow.prototype.next = function (event, options) {
      if (!this.classList?.contains('column-slider__slideshow')) {
        return originalNext.call(this, event, options);
      }

      event?.preventDefault();
      scrollColumnSlider(this, 1, options);
    };

    Slideshow.prototype.previous = function (event, options) {
      if (!this.classList?.contains('column-slider__slideshow')) {
        return originalPrevious.call(this, event, options);
      }

      event?.preventDefault();
      scrollColumnSlider(this, -1, options);
    };

    Slideshow.prototype.__columnSliderScrollFix = true;
  }

  function initColumnSliderSlideshows() {
    document.querySelectorAll('.column-slider__slideshow').forEach((slideshow) => {
      const slides = syncColumnSliderRefs(slideshow);
      if (!slides.length) return;

      bindColumnSliderScroller(slideshow);

      if (slideshow.hasAttribute('data-column-slider-inited')) {
        updateColumnSliderControls(slideshow);
        return;
      }

      slideshow.setAttribute('data-column-slider-inited', '');
      syncColumnSliderCurrent(slideshow);
    });
  }

  function scheduleColumnSliderPatch() {
    enhanceColumnSliderNavigation();
    initColumnSliderSlideshows();
    requestAnimationFrame(initColumnSliderSlideshows);
  }

  function bootColumnSlider() {
    if (customElements.get('slideshow-component')) {
      scheduleColumnSliderPatch();
      return;
    }

    customElements.whenDefined('slideshow-component').then(scheduleColumnSliderPatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootColumnSlider);
  } else {
    bootColumnSlider();
  }

  document.addEventListener('shopify:section:load', bootColumnSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
